import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=5cf10de3&scoped=true"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=5cf10de3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf10de3",
  null
  
)

export default component.exports